import { http, httpgst } from '../../main'
import { store } from '../../store'

const state = {}

const getters = {}

const actions = {
  setting_get ({commit, dispatch}, payload) {
    let url = 'api/settings'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('settingGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  periods_get ({commit, dispatch}, payload) {
    let url = 'api/catalog/periods_types'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onPeriodsGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  setting_post ({commit, dispatch}, payload) {
    let url = 'api/settings'
    let params = payload.event.item
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {})
      .then(
        response => {
          commit('settingPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  setting_put ({commit, dispatch}, payload) {
    let url = 'api/settings/' + payload.event.id
    let params = payload.event.item
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {})
      .then(
        response => {
          commit('settingPut', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  setting_delete ({commit, dispatch}, payload) {
    let url = 'api/settings/' + payload.event.item.id
    let params = {
      'value': payload.event.item.value
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {data: params}, {})
      .then(
        response => {
          commit('settingDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  company_get ({commit, dispatch}, payload) {
    let url = 'api/company'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('companyGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  settingType_get ({commit, dispatch}, payload) {
    let url = 'api/catalog/gst_setting_type'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('settingtypeGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

const mutations = {
  settingGet (state, payload) {
    let settings = payload.response.data.data
    settings.forEach(item => {
      item.value = JSON.parse(item.value)
    })
    payload.event.context.settings = settings
    payload.event.context.loadingItems = false
  },
  onPeriodsGet (state, payload) {
    let periodsTypes = payload.response.data.data
    payload.event.context.periodsType = periodsTypes
  },
  settingPost (state, payload) {
    // let setting = payload.response.data.data
    // setting.company_id = setting.company_id
    // setting.gst_setting_type_id = setting.gst_setting_type_id
    // setting.value = setting.value
    // let settings = payload.event.context.settings
    // settings.push(setting)
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.refresh()
    payload.event.context.close()
  },
  settingPut (state, payload) {
    // let setting = payload.response.data.data
    // setting.company_id = setting.company_id
    // setting.gst_setting_type_id = setting.gst_setting_type_id
    // setting.value = setting.value
    // let settings = payload.event.context.settings
    // settings.splice(payload.event.index, 1, setting)
    // payload.event.context.settings = settings
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.refresh()
    payload.event.context.close()
  },
  settingDelete (state, payload) {
    // let settings = payload.event.context.settings
    // settings.splice(payload.event.index, 1)
    // payload.event.context.settings = settings
    payload.event.context.showNotification(payload.event.context.$t('general.settingDelete'), 'success')
    payload.event.context.refresh()
  },
  companyGet (state, payload) {
    let companies = payload.response.data.data
    payload.event.context.companies = companies
    // payload.event.context.defaultItem.company_id = company
    // payload.event.context.editedItem.company_id = company
  },
  settingtypeGet (state, payload) {
    let settingType = payload.response.data.data
    payload.event.context.settingType = settingType
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js